
import { defineComponent, reactive } from 'vue';
import { useFormat } from 'vivat-next';

import useDownloadReport from '@/use/useDownloadReport';

const NOW = useFormat.date().computerShortDate();

const DriverIncomeCsvReport = defineComponent({
  setup() {
    const { getCSVReport } = useDownloadReport();
    const filter = reactive({
      type: 'fee',
      range: {
        from: undefined,
        to: undefined,
      },
    });

    return {
      filter,
      getCSVReport,
    };
  },
});

export default DriverIncomeCsvReport;
